import { createStore } from 'vuex'

export default createStore({
  state: {
    currentStep: 0,
    currentCategory: null,
    currentScores: null,
    fields: [],
    steps: [
      {
        id: 0,
        component: 'Intro'
      },
      {
        id: 1,
        component: 'Directions'
      },
      {
        id: 2,
        component: 'MainTable'
      },
      {
        id: 3,
        component: 'Answer'
      },
      {
        id: 4,
        component: 'Resources'
      },
      {
        id: 5,
        component: 'Congrats'
      },
    ],
    blocks: [
      {
        categoryID: 'c1',
        categoryName: 'INTERVIEW DO’S AND DON’TS',
        categoryImage: require('@/assets/images/answer-img1.png'),
        items: [
          {
            scores: '100',
            answerImg: require('@/assets/images/answer-c1-1.png'),
            question: 'True or False?',
            questionText: 'As long as it’s clean, it’s good enough to wear to the interview…right?',
            answer: 'False.',
            answerDescription: 'While cleanliness is important, other factors, such as choosing appropriate and neat attire, can make a significant difference in how you present yourself.',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '200',
            answerImg: require('@/assets/images/answer-c1-2.png'),
            question: 'True or False?',
            questionText: 'Bringing a few printed copies of my résumé is a smart idea.',
            answer: 'True.',
            answerDescription: 'You never know if your interviewers will have your résumé on hand. Offering them a copy to use for reference is a thoughtful gesture.',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '300',
            answerImg: require('@/assets/images/answer-c1-3.png'),
            question: 'True or False?',
            questionText: 'I want to wear my favorite dress shirt. It doesn’t matter that it’s a polyester blend.',
            answer: 'False.',
            answerDescription: 'If you’re like lots of people, your adrenaline and nerves might be on high alert during an interview. That can lead to a sweaty situation for some. Try calming your nerves with a breathable fabric like cotton that won’t trap heat and moisture.',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '400',
            answerImg: require('@/assets/images/answer-c1-4.png'),
            question: 'True or False?',
            questionText: 'Sleeping on cotton sheets can help prepare me for my interview.',
            answer: 'True.',
            answerDescription: 'Getting a good night’s sleep before an interview or big event is sound advice. The breathability of cotton sheets can help you wake up feeling refreshed, alert, and ready to take on the challenge.',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '500',
            answerImg: require('@/assets/images/answer-c1-5.png'),
            question: 'True or False?',
            questionText: 'Silencing my phone before the interview makes a good impression. ',
            answer: 'True.',
            answerDescription: 'It signals to the interviewers that you’re present and invested in the conversation.',
            isRevealed: false,
            isShowed: false
          }
        ]
      },
      {
        categoryID: 'c2',
        categoryName: 'SURPRISE ME',
        categoryImage: require('@/assets/images/answer-img2.png'),
        items: [
          {
            scores: '100',
            answerImg: require('@/assets/images/answer-c2-1.png'),
            question: 'True or False?',
            questionText: 'The birthplace of denim is Germany.',
            answer: 'False.',
            answerDescription: 'It’s Nîmes, France. (Originally, the fabric was called serge de Nîmes.)',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '200',
            answerImg: require('@/assets/images/answer-c2-2.png'),
            question: 'True or False?',
            questionText: 'Denim was created in the 20th century.',
            answer: 'False.',
            answerDescription: 'Denim dates back to the 17th century. Its durability and comfort helped it gain popularity in Britain and Italy for jeans and men’s topcoats.',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '300',
            answerImg: require('@/assets/images/answer-c2-3.png'),
            question: 'True or False?',
            questionText: 'U.S. paper currency is made of trees.',
            answer: 'False.',
            answerDescription: 'It’s all fabric: 75% cotton and 25% linen..',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '400',
            answerImg: require('@/assets/images/answer-c2-4.png'),
            question: 'True or False?',
            questionText: 'California is the largest cotton producer in the United States.',
            answer: 'False.',
            answerDescription: 'Cotton is produced in 17 states, and Texas is the leading producer in the United States. ',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '500',
            answerImg: require('@/assets/images/answer-c2-5.png'),
            question: 'True or False?',
            questionText: 'Cotton has been grown and used to make fabric for 7,000 years.',
            answer: 'True.',
            answerDescription: 'The earliest production of cotton was in India, dating back to the fifth millennium B.C.',
            isRevealed: false,
            isShowed: false
          }
        ]
      },
      {
        categoryID: 'c3',
        categoryName: 'NAME THE EVENT',
        categoryImage: require('@/assets/images/answer-img3.png'),
        items: [
          {
            scores: '100',
            answerImg: require('@/assets/images/answer-c3-1.png'),
            question: false,
            questionText: 'Water bottle, hand towel, cotton t-shirt, shorts, sneakers or cleats',
            answer: false,
            answerDescription: 'Sports practice or game',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '200',
            answerImg: require('@/assets/images/answer-c3-2.png'),
            question: false,
            questionText: 'Tablet cued to sheet music, water bottle, name tag, crisp cotton outfit ',
            answer: false,
            answerDescription: 'Music performance',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '300',
            answerImg: require('@/assets/images/answer-c3-3.png'),
            question: false,
            questionText: 'Business casual outfit in breathable fabric, résumés, pen, winning smile',
            answer: false,
            answerDescription: 'Internship or job interview',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '400',
            answerImg: require('@/assets/images/answer-c3-4.png'),
            question: false,
            questionText: 'Laptop, class notes, textbook, heap of snacks, cotton pj’s',
            answer: false,
            answerDescription: 'Studying for an exam or completing a writing project',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '500',
            answerImg: require('@/assets/images/answer-c3-5.png'),
            question: false,
            questionText: 'Comfortable outfit in breathable cotton, course schedule, campus or school building map, loaded backpack',
            answer: false,
            answerDescription: 'First day of school',
            isRevealed: false,
            isShowed: false
          }
        ]
      },
      {
        categoryID: 'c4',
        categoryName: 'COTTON SUSTAINABILITY',
        categoryImage: require('@/assets/images/answer-img4.png'),
        items: [
          {
            scores: '100',
            answerImg: require('@/assets/images/answer-c4-1.png'),
            question: 'True or False?',
            questionText: 'While cotton is sustainable, it is the least flexible fabric for dying into a myriad of colors.',
            answer: 'False.',
            answerDescription: 'Cotton textiles are great for absorbing color dyes, so go for that color! ',
            isRevealed: false,
            isShowed: false,
            class: 'text-start'
          },
          {
            scores: '200',
            answerImg: require('@/assets/images/answer-c4-2.png'),
            question: 'True or False?',
            questionText: 'Cotton clothing gets its start on a farm, while polyester is derived from crude oil.',
            answer: 'True.',
            answerDescription: 'Cotton is natural and grown from the earth and spun into yarn, while polyester is created in a lab from the same type of crude oil that is used to fuel cars.',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '300',
            answerImg: require('@/assets/images/answer-c4-3.png'),
            question: 'True or False?',
            questionText: 'The best way to care for most cotton clothes is to air them out, turn them inside out, wash them with like colors and fabrics (don’t overstuff the washing machine), and don’t over-dry them.',
            answer: 'True.',
            answerDescription: 'Be sure to check the label for cotton and washing instructions. ',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '400',
            answerImg: require('@/assets/images/answer-c4-4.png'),
            question: 'True or False?',
            questionText: 'All clothing sheds microplastics when washed, which end up in waterways.',
            answer: 'False.',
            answerDescription: 'When clothes are laundered, they produce microfibers, miniscule fibers that shed through regular wear and get into our waterways. Microplastics are microfibers made of polyester that get into aquatic environments and persist because they don’t biodegrade easily. Fabric made of 100% cotton is biodegradable, so does not contribute to widespread microplastic pollution.',
            isRevealed: false,
            isShowed: false
          },
          {
            scores: '500',
            answerImg: require('@/assets/images/answer-c4-5.png'),
            question: 'True or False?',
            questionText: 'Worn-out denim apparel is useless and has to be thrown away.',
            answer: 'False.',
            answerDescription: 'Since 2006, Cotton Incorporated’s Blue Jeans Go Green™ recycling program has been recycling denim to create natural insulating material for pet beds, homes, and more.',
            isRevealed: false,
            isShowed: false
          }
        ]
      },
    ],
    directions: {
        items: [
          'Check out the four categories on the game board.',
          'Click a category and value — for example, Name the Event for 200 — to reveal a question.',
          'State or write down your response and then click the Reveal Answer button. <ul><li>If you are correct, your team gets to choose again. </li><li>If not, the other team chooses next.</li></ul>',
          'Tally your points as you play to determine the winner.'
        ]
      },
      resources: {
        items: [
          '<p><span>CottonWorks™:</span><strong>cottonworks.com/en/topics/sourcing-manufacturing/dyeing</strong></p>',
          '<p><span>The Fabric of Our Lives:</span> <strong>thefabricofourlives.com/the-benefits-of-cotton/sustainability</strong></p>',
          '<p><span>Cotton Inc.:</span> <strong>cottoninc.com/about-cotton/pressroom/did-you-know</strong></p>',
          '<p><span>Blue Jeans Go Green™:</span> <strong>bluejeansgogreen.org</strong></p>',
        ]
      },
    isAnswerActive: false,
    soundEnabled: false,
    revealedQuestions: 0,
    curAnswerObj: {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    },
    audio: [
      {
        id: 'theme_music',
        src: require('@/assets/media/theme_music.mp3'),
        playing: false,
        loop: true
      },
      {
        id: 'question_reveal',
        src: require('@/assets/media/question_reveal.mp3'),
        playing: false,
        loop: false
      },
      {
        id: 'answer_reveal',
        src: require('@/assets/media/answer_reveal.mp3'),
        playing: false,
        loop: false
      },
      {
        id: 'congrats',
        src: require('@/assets/media/cheers-with-fadeout.mp3'),
        playing: false,
        loop: false
      },
    ],
  },

  getters: {
    getBlocks: s => s.blocks,
    getAnswers: s => {
      let answers = []
      Array.from(s.blocks).forEach(block => {
        answers = [...answers, ...block.items]
      })
      return answers
    },
    getBlocksLength: s => s.blocks[0].items.length,
    getDirectionsItems: s => s.directions.items,
    getResourcesItems: s => s.resources.items,
    getCurrentStepIndex: s => s.currentStep,
    getCurrentStep: s => s.steps.find(step => step.id === s.currentStep),
    getCurrentCategory: s => s.blocks.find(block => block.categoryID === s.currentCategory),
    getCurrentAnswer: (s, getters) => getters.getCurrentCategory.items.find(item => item.scores === s.currentScores),
    getSound: s => id => s.audio.find((sound) => sound.id === id),
    getSounds: s => s.audio,
    getAnswerState: s => s.isAnswerActive,
    getAnswerPos: s => s.curAnswerObj,
    getSoundState: s => s.soundEnabled,
    getRevealedQuestions: s => s.revealedQuestions
  },
  mutations: {
    nextStep: (s) => {
      const { currentStep } = s;
      console.log({ currentStep });
      if (currentStep < s.steps.length - 1) {
        s.currentStep = currentStep + 1;
      }
    },
    goToStep: (s, num) => {
      s.currentStep = num;
    },
    goToAnswer: (s, {categoryID, scores}) => {
      s.isAnswerActive = true;
      s.currentCategory = categoryID;
      s.currentScores = scores;
    },
    play: (s, id) => {
      s.audio.find((a) => a.id === id).playing = true;
    },
    stop: (s, id) => {
      s.audio.find((a) => a.id === id).playing = false;
    },
    hideAnswer: s => s.isAnswerActive = false,
    updateAnswerPos: (s , obj) => {
      s.curAnswerObj.left = obj.left;
      s.curAnswerObj.top = obj.top;
      s.curAnswerObj.width = obj.width;
      s.curAnswerObj.height = obj.height;
    },
    switchSoundState: s => s.soundEnabled = !s.soundEnabled,
    updateRevealedQuestions: s => s.revealedQuestions++
  },
  actions: {
  },
  modules: {
  }
})
